import React from 'react'
import { useWindowDimensions, View } from 'react-native'

export function ResponsiveSplit({ left, right, topMargin = 0 }: { left: React.ReactNode; right: React.ReactNode; topMargin?: number }) {
  const { width } = useWindowDimensions()
  const isStacked = width < 960

  return (
    <View style={{ flexDirection: isStacked ? 'column' : 'row', gap: 32, alignItems: 'stretch', marginTop: topMargin }}>
      <View style={{ flex: 1 }}>{left}</View>
      <View style={{ flex: 1 }}>{right}</View>
    </View>
  )
}
